import React from "react";

import Lic4 from "./Lic4.jpeg";
import Lic3 from "./Lic3.png";
import agent1 from "./agent1.jpeg";
import Super from "./Super";
import Lic8 from './Lic8.jpg'
import Lic9 from './Lic9.jpg'
import Lic11 from './Lic11.jpg'

const Licinfo = () => {
  return (
    <>
      <section id="lic">
        <div className="container my-3 text-center">
          <div className="row">
            <div className="col-md-12">
              <img src={Lic4} alt="" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h1>About LIc</h1>
              <p>
                LIC (Life Insurance Corporation) is an Indian state-owned
                insurance group and investment company that provides life
                insurance plans and policies to the people. The journey of LIC
                started over six decades ago and we are still confident that,
                while insurance maybe a business for us, being part of millions
                of lives every day for the past 61 years has been a process
                called Trust. We are delighted by the magnitude of
                responsibility we possess and realize the lives that are
                associated with us are very valuable. LIC is one of the leading
                insurance companies which is trusted throughout the country.
              </p>
            </div>
            <div className="col-md-6">
              <img src={Lic3} alt="" />
            </div>
          </div>
        </div>
      </section>
      <section id="lic1">
        <div className="container my-3 text-center">
          <div className="row">
            <div className="col-md-6">
              <img className="lic" src={agent1} alt="" />
            </div>
            <div className="col-md-6">
              <h1>Why LIC:</h1>
              <p>
                LIC whole life insurance plan, this policy provides yearly
                survival benefits from the end of the premium paying term until
                maturity. Additionally, it pays out a lump sum amount at the
                time of maturity or on the demise of the life assured during the
                policy period. LIC has the most entrenched network of advisors
                and its a legacy of fifty years plus It takes care of your
                family’s future Even after a person's demise, an LIC policy will
                look after that person’s family and will make sure that their
                future is secure. LIC helps you live a comfortable retired life.
                After a certain period of time, instead of paying premiums you
                can enjoy a regular income from your LIC policy. It helps in
                saving taxes. LIC premiums are exempted from taxation. In
                addition, in some cases, money received on maturity of a policy
                or death claims are also tax free. LIC helps in reducing debt.
                Having the right insurance policy can protect you against car
                loans, home loans and other forms of outstanding debts.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="lic3" className="">
        <div className="container my-3 text-center">
          <div className="row">
            <div className="col-md-4">
<img src={Lic8} alt=""/>
<h2>Pay Through eWallet</h2>
<p>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
            <div className="col-md-4">
            <img src={Lic9} alt=""/>
            <h2>LIC Agent jobs</h2>
            <p>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
            <div className="col-md-4">
            <img src={Lic11} alt=""/>
            <h2>New Agent & DO App</h2>
            <p>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
        </div>
      </section>
      <Super />
    </>
  );
};

export default Licinfo;
